import axios, { AxiosResponse } from "axios";

import { ServerModelWithDateStrings } from "@teamprevent/common/utils";

import {
    AccessGroupDetailModel,
    AccessGroupListModel } from "./models";
import { AccessGroupFormModel } from "./schema";

const apiUrl = "/api/accessGroups";

const getAll = async (): Promise<AccessGroupListModel[]> => {
    const response = await axios.get<ServerModelWithDateStrings<AccessGroupDetailModel[]>>(apiUrl);
    return response.data;
};

const get = async (id: string): Promise<AccessGroupDetailModel> => {
    const response = await axios.get<ServerModelWithDateStrings<AccessGroupDetailModel>>(`${apiUrl}/${id}`);
    return response.data;
};

const create = async (accessGroup: AccessGroupFormModel): Promise<AccessGroupListModel> => {
    const response = await axios.post<
        ServerModelWithDateStrings<AccessGroupListModel>,
        AxiosResponse<ServerModelWithDateStrings<AccessGroupListModel>>,
        ServerModelWithDateStrings<AccessGroupFormModel>
    >(`${apiUrl}`, accessGroup);

    return response.data;
};

const update = async (accessGroup: AccessGroupFormModel): Promise<AccessGroupDetailModel> => {
    const response = await axios.put<
        ServerModelWithDateStrings<AccessGroupDetailModel>,
        AxiosResponse<ServerModelWithDateStrings<AccessGroupDetailModel>>,
        ServerModelWithDateStrings<AccessGroupFormModel>
    >(`${apiUrl}/${accessGroup.id}`, accessGroup);

    return response.data;
};

export const AccessGroupApi = { getAll, get, create, update };
